import { useState, useRef, useEffect } from "react";

function FileUpload({ label, icon, currentImage, file, onFileChange, onRemove, accept = "image/*" }) {
  const [dragActive, setDragActive] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [currentImage, file]);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      if (droppedFile.type.startsWith("image/")) {
        onFileChange(droppedFile);
      }
    }
  };

  const handleFileSelect = (e) => {
    if (e.target.files && e.target.files[0]) {
      onFileChange(e.target.files[0]);
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setImageError(false);
    setImageLoaded(false);
    onRemove();
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  const displayImage = file ? URL.createObjectURL(file) : currentImage;
  const hasImage = displayImage && !imageError;

  return (
    <div className="file-upload-wrapper">
      <label className="file-upload-label">{label}</label>

      <div
        className={`file-upload-zone ${dragActive ? "drag-active" : ""} ${hasImage ? "has-image" : ""}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        {hasImage ? (
          <div className="file-upload-preview">
            <img
              src={displayImage}
              alt={label}
              onLoad={handleImageLoad}
              onError={handleImageError}
              style={{ opacity: imageLoaded ? 1 : 0 }}
            />
            <div className="file-upload-overlay">
              <div className="file-upload-overlay-content">
                <i className="fas fa-camera" />
                <span>Change Image</span>
              </div>
            </div>
            <button
              type="button"
              className="file-upload-remove"
              onClick={handleRemove}
              title="Remove image"
            >
              <i className="fas fa-times" />
            </button>
          </div>
        ) : (
          <div className="file-upload-placeholder">
            <div className="file-upload-icon">
              <i className={`fas ${icon}`} />
            </div>
            <p className="file-upload-text">
              <span className="file-upload-text-bold">Click to upload</span>
              <span> or drag and drop</span>
            </p>
            <p className="file-upload-hint">PNG, JPG, WEBP (max 5MB)</p>
          </div>
        )}

        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={handleFileSelect}
          className="file-upload-input"
        />
      </div>
    </div>
  );
}

export default FileUpload;
